module.exports = __webpack_public_path__ + "img/Ill_Skill Details_Endorsement.5f3bcd65.svg";